// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getErpSystemStatus } from "@adl/App/Store/Selectors/CartSelectors";
import Modal from "@adl/MobiusOverrides/Modal/Modal";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import {
    getCartState,
    getCurrentCartState,
    hasProductsWithInvalidPrice,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Typography from "@insite/mobius/Typography";
import React, { FC } from "react";
import { connect } from "react-redux";

interface OwnProps {
    styles?: ButtonPresentationProps;
    // XNG-Changes
    disabled?: boolean;
}

const mapStateToProps = (state: ApplicationState) => {
    const { cartId, isPlacingOrder, isCheckingOutWithPayPay } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const billToState = getBillToState(state, cartState.value?.billToId);
    const shipToState = getShipToState(state, cartState.value?.shipToId);
    // <XNG-Changes>
    const { erpSystemIsDown } = getErpSystemStatus(state, cartId);
    // </XNG-Changes>
    const { sessionId, redirectResult } = parseQueryString<{ sessionId?: string; redirectResult?: string }>(
        getLocation(state).search,
    );

    return {
        isDisabled:
            cartState.isLoading ||
            billToState.isLoading ||
            !billToState.value ||
            shipToState.isLoading ||
            !shipToState.value ||
            !billToState.value.address1 ||
            !shipToState.value.address1 ||
            isPlacingOrder ||
            isCheckingOutWithPayPay ||
            (!!sessionId && !!redirectResult) ||
            hasProductsWithInvalidPrice(cartState.value) ||
            cartState.value?.hasInsufficientInventory === true ||
            erpSystemIsDown,
        // XNG-Changes
        isPlacingOrder: state.pages.checkoutReviewAndSubmit.isPlacingOrder,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const CheckoutReviewAndSubmitPlaceOrderButton: FC<Props> = ({
    isDisabled,
    disabled,
    styles,
    // XNG-Changes
    isPlacingOrder,
}) => {
    const handleClick = () => {
        document.getElementById("reviewAndSubmitPaymentForm-submit")?.click();
    };
    return (
        <>
            <Button
                type="submit"
                disabled={isDisabled || disabled}
                data-test-selector="checkoutReviewAndSubmit_placeOrder"
                {...styles}
                onClick={handleClick}
            >
                {/* XNG-Changes: change tite */}
                {translate("Submit Order")}
            </Button>
            {/* XNG-Changes - ADL-1424: add pop-up modal when placing an order */}
            <Modal
                headline={siteMessage("Custom_OrderSubmissionInProgressNoticeModalHeadline")}
                isOpen={isPlacingOrder}
                isCloseable={false}
            >
                <Typography>{siteMessage("Custom_OrderSubmissionInProgressNotice")}</Typography>
            </Modal>
        </>
    );
};

export default connect(mapStateToProps)(CheckoutReviewAndSubmitPlaceOrderButton);
